import { baseApi } from "..";
import { checkIsAdmin } from "../../../helpers/helpers";

// Define a service using a base URL and expected endpoints
export const prodApprovalsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllPreProdApprovals: builder.query({
      query: ({ type = "design" }) =>
        checkIsAdmin()
          ? `pre-production-order-approvals?type=${type}`
          : `customer/pre-production-order-approvals?type=${type}`,
      transformResponse: ({ data }) =>
        data.map((row) => ({
          ...row,
          production_order: row?.production_order?.id || "_",
          org_name: row?.production_order?.organization?.name || "_",
          created_at: row?.created_at || "_",
          item_description: row?.item_description || "_",
        })),
    }),

    getProdApprovalsById: builder.query({
      query: (id) =>
        checkIsAdmin()
          ? `pre-production-order-approvals/${id}`
          : `customer/pre-production-order-approvals/${id}`,
      transformResponse: (response) => response.data,
    }),

    initiatePreProductionApproval: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `pre-production-order-approvals/${id}`,
        method: "PUT",
        body: { ...patch, status: "submitted" },
      }),
      transformResponse: (response) => response.data,
    }),

    uploadApprovalImage: builder.mutation({
      query: ({ type, formData: body }) => ({
        url: `images/${type}`,
        method: "POST",
        body,
        formData: true,
      }),
      transformResponse: (response) => response.data,
    }),

    rejectOrApprovePreProductionApproval: builder.mutation({
      query: ({ id, accept, note }) => ({
        url:
          `customer/pre-production-order-approvals/${id}/` +
          (accept ? `accept` : `reject`),
        method: "PUT",
        body: !accept ? { rejected_note: note } : undefined,
      }),
      transformResponse: (response) => response.data,
    }),

    skipDesignApproval: builder.mutation({
      query: ({ id }) => ({
        url: `pre-production-order-approvals/${id}/skip-design`,
        method: "PUT",
      }),
      transformResponse: (response) => response.data,
    }),

    skipOverallPatternApproval: builder.mutation({
      query: ({ id }) => ({
        url: `pre-production-order-approvals/${id}/skip-design-prototype`,
        method: "PUT",
      }),
      transformResponse: (response) => response.data,
    }),
  }),

  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllPreProdApprovalsQuery,
  useGetAllProtoTypeApprovalsQuery,
  useGetProdApprovalsByIdQuery,
  useInitiatePreProductionApprovalMutation,
  useUploadApprovalImageMutation,
  useRejectOrApprovePreProductionApprovalMutation,
  useSkipDesignApprovalMutation,
  useSkipOverallPatternApprovalMutation,
} = prodApprovalsApi;
